import { AnalyticsStore } from 'bernie-plugin-mobx';
import { getPageIdentityFromId } from 'utils/page-identity';
import { BERNIE_CARS_EGTP, BERNIE_CARS_LEGACY } from 'src/constants';

interface AnalyticsPayload {
  adobeMappedData: {
    pageURL: string;
    prop2: string;
    prop12: string;
    prop36?: string;
    pageName: string;
  };
  context: any;
}

class AnalyticsUtil {
  private shouldPublishAnalyticsPayload = true;
  private shouldMarkPageUsable = true;
  public resetAnalyticsPayLoad(analytics: AnalyticsStore): void {
    analytics.resetAnalyticsForNewPage();
    this.shouldPublishAnalyticsPayload = true;
    this.shouldMarkPageUsable = false;
  }

  public publishAnalyticsPayload(response, analytics: AnalyticsStore): void {
    const isValidPayload = response && response.extensions && response.extensions.analytics;

    if (this.shouldPublishAnalyticsPayload && isValidPayload) {
      const analyticsPayLoad = response.extensions.analytics;

      analytics.publishClientSidePayload(analyticsPayLoad);
      this.shouldMarkPageUsable = true;
    }
  }

  //This method is used when we have to do omniture logging without having analytics payload from bex-api. For example, error logging when bex-api is down or omniture logging on loading view
  public publicCustomClientSideAnalyticsPayload(
    pageId: string,
    analytics: AnalyticsStore,
    duaid: string,
    error?: string
  ): void {
    if (this.shouldPublishAnalyticsPayload) {
      const pageIdentity = getPageIdentityFromId(pageId);
      const analyticsPayLoad: AnalyticsPayload = {
        adobeMappedData : {
          pageURL  : window.location.href,
          prop2    : 'cars.20',
          prop12   : duaid,
          prop36   : error,
          pageName : pageIdentity.pageId
        },
        context : {}
      };
      analytics.publishClientSidePayload([analyticsPayLoad]);
      this.resetAnalyticsPayLoad(analytics);
    }
  }

  public markPageUsableIfNeeded(analyticsStore: AnalyticsStore, carsPlatformBucketValue: boolean): void {

    const customPerformanceMetrics = {
      microMessages : [
        {
          schemaName     : 'experiencePlatform',
          messageContent : {
            pagePlatform : carsPlatformBucketValue ? BERNIE_CARS_EGTP : BERNIE_CARS_LEGACY
          }
        }
      ]
    };

    if (this.shouldMarkPageUsable) {
      analyticsStore.markPageUsable(customPerformanceMetrics);
      this.shouldMarkPageUsable = false;
    }
  }


  public disableFurtherAnalyticsPayLoad(): void {
    this.shouldPublishAnalyticsPayload = false;
    this.shouldMarkPageUsable = true;
  }

  public disablePageUsable(): void {
    this.shouldMarkPageUsable = true;
  }
}

const analyticsUtil = new AnalyticsUtil();

export default analyticsUtil;
